import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-event-activities',
  templateUrl: './event-activities.component.html',
  styleUrls: ['./event-activities.component.scss']
})
export class EventActivitiesComponent implements OnInit {

  @Input() year: string;
  @Input() activities: any;

  constructor() { }

  ngOnInit(): void {
  }

}
